import React from 'react';

import { Icon, Text } from '@betterment/samba-react';
import { Box, Button, CenteredWorkflowLayout, Flex, Heading, SectionLayout } from '@betterment/style-closet-react';

import CheckingSplashImage from '../../../images/checking_splash.png';
import Footer from '../../../Shared/components/Footer';

interface Props {
  handleClick: () => void;
}
interface PerkProps {
  icon: React.JSX.Element;
  text: string;
}

const Perk: React.FC<React.PropsWithChildren<PerkProps>> = ({ icon, text }) => {
  return (
    <Box mb="7">
      <Flex flexDirection="row" alignItems="top">
        <Box mr="2">{icon}</Box>
        <Text as="p" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
          {text}
        </Text>
      </Flex>
    </Box>
  );
};

const Checking: React.FC<React.PropsWithChildren<Props>> = ({ handleClick }) => {
  const disclosureAltText =
    'The Betterment Visa® Debit Card will be issued by nbkc bank; Member FDIC. Debit cards will accompany Checking accounts.';

  return (
    <CenteredWorkflowLayout title="Checking">
      <CenteredWorkflowLayout.Slot name="content">
        <Box mb="8">
          <Box maxWidth="60rem" m="0 auto" mb={['6', '6', '0']}>
            <img src={CheckingSplashImage} alt={disclosureAltText} width="100%" />
          </Box>
        </Box>
        <Heading color="bmtGrey90">Betterment Checking</Heading>
        <Flex justifyContent="center">
          <Box width="100%">
            <SectionLayout pb="6" px="0">
              <Box pb={[9, 9, 0]}>
                <Text
                  as="p"
                  css={{
                    marginBottom: 'space.300',
                  }}
                >
                  Our FDIC-insured&Dagger; Checking account takes the hassle out of traditional checking. No credit
                  check required to sign up.
                </Text>
                <Perk
                  icon={<Icon name="Cancel" size="small" color="icon" />}
                  text="No fees&Dagger; or minimum balances."
                />
                <Perk
                  icon={<Icon name="AtmCash" size="small" color="icon" />}
                  text="ATM and foreign transaction fees reimbursed worldwide."
                />
                <Perk
                  icon={<Icon name="People" size="small" color="icon" />}
                  text="Joint accounts for you and your partner to manage your expenses together."
                />
                <Perk
                  icon={<Icon name="ArrowCircle" size="small" color="icon" />}
                  text="Automatic transfers into your Cash Reserve and Investment goals."
                />

                <Button type="button" width={[1, 1 / 3]} onClick={handleClick}>
                  Continue
                </Button>
              </Box>
            </SectionLayout>
          </Box>
        </Flex>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer showCheckingDisclosure={true} />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default Checking;
